/*  MUI  */
import { Box, CircularProgress, Paper, Tab } from '@mui/material';

/*  Shared  */
import { MUISubtabsWrapper } from 'application/Shared/Components/MUITabsWrapper';

/* Hooks */
import { useFetchSingleUser } from 'hooks/dataAccess/User/user';

/*  React  */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

/*  Components  */
import Applications from './Pages/Applications';
import Settings from './Pages/Settings';

const UserAdminTabs = ({ tab, setTab }) => {
    const { t } = useTranslation();

    return (
        <MUISubtabsWrapper
            className="nestedTabs"
            value={tab}
            onChange={(_e, v) => setTab(v)}
        >
            <Tab
                className="nestedTabs"
                value="applications"
                label={
                    <span
                        style={{
                            alignItems: 'center',
                            display: 'flex'
                        }}
                    >
                        {t('Common.applications')}
                    </span>
                }
                aria-label="Applications"
            />
            <Tab
                className="nestedTabs"
                value="settings"
                label={
                    <span
                        style={{
                            alignItems: 'center',
                            display: 'flex'
                        }}
                    >
                        {t('Common.settings')}
                    </span>
                }
                aria-label="Settings"
            />
        </MUISubtabsWrapper>
    );
};

const UserAdminContent = ({ tab, userId, user }) => {
    switch (tab) {
        case 'applications':
            return <Applications userId={userId} user={user} />;
        case 'settings':
            return <Settings user={user} />;
        default:
            return null;
    }
};

export const UserAdmin = () => {
    const [tab, setTab] = useState('applications');
    const { clientId, userId } = useParams();

    const { user, loading } = useFetchSingleUser({
        clientId,
        userId
    });

    return loading ? (
        <Box display="flex" justifyContent="center">
            <CircularProgress />
        </Box>
    ) : (
        <Box data-testid="adminUserAdminDashboard">
            <UserAdminTabs tab={tab} setTab={setTab} />
            <Paper elevation={0} variant="outlined">
                <UserAdminContent tab={tab} userId={userId} user={user} />
            </Paper>
        </Box>
    );
};
